import { useState } from "react";
import styles from "./ProfileImage.module.css";
import { apiUrl as getApiUrl } from "../lib/runtimeConfig";

const PROFILE_PLACEHOLDER = "/assets/placeholder-profile.svg";

type ProfileImageProps = {
  src: string;
  alt?: string;
  variant: "default" | "small" | "medium" | "large" | "xl" | "journey-card" | "journey-card-mobile";
  className?: string;
};

const toStaticProfileUrl = (val: string): string => {
  const apiUrl = getApiUrl();
  if (!val) return PROFILE_PLACEHOLDER;
  if (val.startsWith("data:")) return val;
  if (/^https?:\/\//i.test(val)) return val;
  if (val.startsWith("/files/") || val.startsWith("/images/")) return `${apiUrl}${val}`;
  return `${apiUrl}/files/profile/${val}`;
};

const ProfileImage = ({ src, alt = "", variant = "default", className }: ProfileImageProps) => {
  const [hasError, setHasError] = useState(false);
  const finalSrc = hasError ? PROFILE_PLACEHOLDER : toStaticProfileUrl(src);

  return (
    <span className={[styles.wrapper, className].filter(Boolean).join(" ")}>
      <img
        alt={alt}
        className={[styles.image, styles[variant]].filter(Boolean).join(" ")}
        crossOrigin='anonymous'
        onError={() => setHasError(true)}
        src={finalSrc}
      />
    </span>
  );
};

export default ProfileImage;
